import {

} from "./adminDashboardActions";

const initialState = {

};

const adminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {

    default:
      return state;
  }
};

export default adminDashboardReducer;